import { SkeletonLoader } from "@merge-api/merge-javascript-shared";
import { Integration } from "../../../../models/Entities";
import IntegrationsDashboardGridCard from "./IntegrationsDashboardGridCard";

type Props = {
  integrations: Integration[] | undefined;
  isLoading: boolean;
};

const SKELETON_CARD_COUNT = 18;
const CARD_SIZE_PX = 128;

const IntegrationsDashboardGrid = ({ integrations = [], isLoading }: Props) => {
  // render
  if (isLoading && !integrations.length) {
    return (
      <div className="flex flex-row flex-wrap justify-center gap-6">
        {Array.from({ length: SKELETON_CARD_COUNT }).map((_, index) => (
          <SkeletonLoader key={index} width={CARD_SIZE_PX} height={CARD_SIZE_PX} borderRadius={8} />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-row flex-wrap justify-center gap-6">
      {integrations.map((integration) => (
        <IntegrationsDashboardGridCard key={integration.id} integration={integration} />
      ))}
    </div>
  );
};

export default IntegrationsDashboardGrid;
